import React from "react";
import { type ListTemplateLayout } from "components/ListTemplate/types";
import LinkedShowsList from "components/LinkedShows/LinkedShowsList";
import { formatTime, formatWrittenDayMonthYear } from "utilities";
import { AppointmentPhase } from "components";
import { LargeClickableTitle } from "components/ListTemplate/LargeClickableTitle";
import { TrainSidePanel } from "components/SidePanel/Train/TrainSidePanel";
import { ArtistSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import { FormatArrivalTime } from "flights/lookup/FlightSearchResult";
import moment from "moment";

const TrainFromTo = ({ train }: { train: server.dto.TrainForList }) => {
  const startDateWritten = formatWrittenDayMonthYear(train.dateTime.startDisplay);

  const startTimeWritten = formatTime(train.dateTime.startDisplay);

  return <div className="flex-2 journey-card-grid">
    <div className="departs-from">
      <div className="info-text-regular margin-bottom-large">
        {startDateWritten}
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {train.departure.name}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {train.departure.address.formatted.join(", ")}
      </div>
    </div>
    <div className="departure-time nowrap info-text-regular">
      {startTimeWritten}
    </div>
    <div className="arrow">
      <i className="icon-arrow-right small" />
    </div>
    <div className="arrives-at">
      <div className="info-text-regular margin-bottom-large">
        <FormatArrivalTime
          departure={moment.utc(train.dateTime.startDisplay)}
          arrival={moment.utc(train.dateTime.endDisplay)}
        />
      </div>
      <div className="subtitle-text-regular margin-bottom-small">
        {train.arrival.name}
      </div>
      <div className="text-sublabel margin-bottom-small">
        {train.arrival.address.formatted.join(", ")}
      </div>
    </div>
  </div>;
};

export const cardLayout = (): ListTemplateLayout<server.dto.TrainForList> => ({
  type: "card",
  sections: {
    renderTitle: item =>
      <TrainSidePanel
        trainId={item.trainId}
        trigger={<LargeClickableTitle
          icon={<AppointmentPhase value={item.phase} displayLabel={false} />}
          title={`${item.departure.name} » ${item.arrival.name}`}
        />}
      />,
    hideTitle: () => false,
    renderBody: item => <>
      <TrainFromTo train={item} />
      <LinkedShowsList shows={item.linkedShows} />
    </>,
    renderFooter: item => <div>
      <div className="margin-bottom-small">
        <ArtistSidePanel
          companyId={item.artist.artistId}
          trigger={<a>{item.artist.name}</a>}
        />
      </div>
      <div>
        {item.passengers.map((traveller, index) => <React.Fragment key={traveller.contactId}>
          <span className="s1_gray">{traveller.name.fullName}</span>
          {item.passengers.length - 1 !== index && <span className="s1_gray">, </span>}
        </React.Fragment>)}
      </div>
    </div>,
    hideFooter: item => !item.artist && item.passengers.length === 0
  }
});